export default {"src":"/_next/static/media/Shime.a25eee79.svg","height":48,"width":88};